import leadInsightsService from 'services/lead-insights-service'

// ------------------------------------
// Constants
// ------------------------------------
let LOAD_LEAD_DROP_LEADERS = 'LOAD_LEAD_DROP_LEADERS'
let LOAD_LEAD_SOLD_LEADERS = 'LOAD_LEAD_SOLD_LEADERS'

export function loadLeadDropLeaders(filter) {
  return (dispatch, getState) => {
    return leadInsightsService.getLeadDropLeaders(filter)
      .then((dropLeaders) => {
        dispatch({
          type: LOAD_LEAD_DROP_LEADERS,
          dropLeaders: dropLeaders
        })
      })
  }
}

export function loadLeadSoldLeaders(filter) {
  return (dispatch, getState) => {
    return leadInsightsService.getLeadSoldLeaders(filter)
      .then((soldLeaders) => {
        dispatch({
          type: LOAD_LEAD_SOLD_LEADERS,
          soldLeaders: soldLeaders
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function loadLeadDropLeadersReducer(state = {storeUserLeaders: [], storeLeaders: []}, action) {
  switch (action.type) {
    case LOAD_LEAD_DROP_LEADERS: {
      return action.dropLeaders
    }
    default:
      return state
  }
}

export function loadLeadSoldLeadersReducer(state = {storeUserLeaders: [], storeLeaders: []}, action) {
  switch (action.type) {
    case LOAD_LEAD_SOLD_LEADERS: {
      return action.soldLeaders
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/LeadDropAnalytics/modules/LeadDropLeaderAnalytics.js